var map = {
	"./de-DE/btn_menu-close.png": "a272",
	"./en-GB/btn_menu-close.png": "5dfd",
	"./en-US/btn_menu-close.png": "52e3",
	"./es-ES/btn_menu-close.png": "dcc8",
	"./es-MX/btn_menu-close.png": "e7d2",
	"./fr-CA/btn_menu-close.png": "94cab",
	"./fr-FR/btn_menu-close.png": "4142",
	"./it-IT/btn_menu-close.png": "cc3d",
	"./ja-JP/btn_menu-close.png": "5ec8",
	"./pt-BR/btn_menu-close.png": "64fd",
	"./zh-TW/btn_menu-close.png": "aa36"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fe35";